import { lazy, useRef, useState } from "react";

import Suspense from "components/shared/Suspense";
import { Drawer } from "features/Drawer";
import EditionType from "types/EditionType";
import { EditionSerializersEditionByline } from "types/serializers";

// TODO: #1876 after switching to using EditableProgressForm, remove this folder

const EditablePageProgressDrawer = lazy(
  () => import("./EditablePageProgressDrawer"),
);

export default function EditablePageProgress({
  currentPages,
  edition,
  message,
  onChange,
  pages,
}: Readonly<{
  currentPages: number | null;
  edition: EditionSerializersEditionByline | EditionType;
  message?: string;
  onChange: (progress: number) => Promise<unknown>;
  pages: number | null;
}>) {
  const buttonRef = useRef<HTMLButtonElement>();
  const [isEditing, setIsEditing] = useState(false);

  return (
    <div>
      <button
        type="button"
        className="font-semibold underline decoration-dotted"
        data-tooltip-id="tooltip"
        data-tooltip-content="Click to update"
        ref={buttonRef}
        onClick={() => setIsEditing(true)}
      >
        {currentPages ? currentPages.toLocaleString() : "0"}
      </button>

      {isEditing && buttonRef?.current && (
        <Suspense
          fallback={
            <Drawer.Loading
              settings={{
                ref: buttonRef.current,
                onClose: () => {},
                isOpen: true,
                offset: [-20, 10],
              }}
            />
          }
        >
          <EditablePageProgressDrawer
            attachElement={buttonRef.current}
            currentPages={currentPages}
            edition={edition}
            message={message}
            onChange={onChange}
            onDone={() => setIsEditing(false)}
            pages={pages}
          />
        </Suspense>
      )}
    </div>
  );
}
